export const setDotncommaState = (state, action): any => {
  const updatedState = {
    ...state,
    saveDotncommaResponse: action.payload.status,
  };

  return updatedState;
};
